import React from 'react';
import { filterNotHiddenProducts } from 'common/utilities/utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { RESULTS, WE_FOUND_TEXT } from '../NutritionAllergenConstants/NutritionAllergenConstants';
import { Row } from 'reactstrap';

const SearchItems = ({ searchMode, filterList, isMobile, products }) => {

  return searchMode.isSearchedMode && filterNotHiddenProducts(products) > 0 ? (
    <Row className={(isMobile && 'pt-4 pl-5' ) || 'pt-5'}>
      <h3 className='found-text position-relative'>
        {translateWithI18Next(WE_FOUND_TEXT)} {filterNotHiddenProducts(products)}
        {` "${searchMode.searchedData.toUpperCase()}"`}
      </h3>
    </Row>
  ) : ((([...filterList].length > 0 && filterNotHiddenProducts(products) === 0) && (
    <Row className={isMobile ? 'pt-4 pl-5' : 'pt-5 no-data-found-plp'}>
      <h2 className='found-text position-relative'>
        {WE_FOUND_TEXT} {filterNotHiddenProducts(products)} {RESULTS.toUpperCase()}
      </h2>
    </Row>
  )) || (
    [...filterList].length > 0 &&
    filterNotHiddenProducts(products) > 0 && (
      <Row className={isMobile ? 'pt-4 pl-5' : `pt-5 }`}>
        <h2 className='found-text position-relative'>
          {WE_FOUND_TEXT} {filterNotHiddenProducts(products)} {RESULTS.toUpperCase()}
        </h2>
      </Row>
    )
  ));
};

export default React.memo(SearchItems);
